import React, { useEffect, useState } from "react";
import Datatable from "../../../components/shared/datatable/Datatable";
import { useGetEmployeeAttendanceReportListQuery } from "../employeeAttendanceApi";
import moment from "moment";
import useTranslator from "../../../hooks/useTranslator";

const EmployeeAttendanceReportTab = ({ tab }) => {
  const { _t } = useTranslator();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  // Initialize with This Week date range
  const thisWeekStart = moment().startOf("isoWeek").format("YYYY-MM-DD");
  const thisWeekEnd = moment().endOf("isoWeek").format("YYYY-MM-DD");

  const [filter, setFilter] = useState({
    attendance_start_date: thisWeekStart,
    attendance_end_date: thisWeekEnd,
    dateRange: "This Week", // Add this property to track selected date range
  });

  const [shouldFetch, setShouldFetch] = useState(false);

  const queryArgs = {
    working_area_id: tab,
    page,
    pageSize,
    ...filter,
  };

  const {
    data: employeeAttendanceReportList,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetEmployeeAttendanceReportListQuery(queryArgs, {
    skip: !shouldFetch,
    refetchOnMountOrArgChange: true,
  });

  // Set initial fetch when component mounts
  useEffect(() => {
    setShouldFetch(true);
  }, []);

  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      employee_role_id: "",
      // Maintain the This Week date range when tab changes
      attendance_start_date: thisWeekStart,
      attendance_end_date: thisWeekEnd,
      dateRange: "This Week",
    }));
    setPage(1);
    setShouldFetch(true);
  }, [tab]);

  useEffect(() => {
    setShouldFetch(true);
  }, [filter]);

  useEffect(() => {
    if (employeeAttendanceReportList || isError) {
      setShouldFetch(false);
    }
  }, [employeeAttendanceReportList, isError]);

  const columns = [
    { label: _t("name", "Name"), accessor: "name" },
    { label: _t("email", "Email"), accessor: "email" },
    {
      label: _t("role", "Role"),
      accessor: "role.name",
      captialize: true,
      translate: true,
    },
    {
      label: _t("status", "Status"),
      accessor: "status",
      cell: ({ value }) => (
        <span className={value === 1 ? "cmn_badge" : "cmn_badge inactive"}>
          {value === 1 ? _t("active", "Active") : _t("inactive", "Inactive")}
        </span>
      ),
    },
    {
      label: _t("total_working_days", "Total Working Days"),
      accessor: "total_working_days",
    },
    { label: _t("total_present", "Total Present"), accessor: "total_present" },
    { label: _t("total_absent", "Total Absent"), accessor: "total_absent" },
  ];

  const handlePageChange = (newPage) => {
    setShouldFetch(true);
    setPage(newPage);
  };

  return (
    <div>
        <Datatable
          title={_t("employee_attendance_report", "Employee Attendance Report")}
          columns={columns}
          tableData={employeeAttendanceReportList?.data}
          pagination
          page={page}
          onPageChange={handlePageChange}
          showFilter={setFilter}
          showFilterButton={true}
          filterModule="staffAttendanceReport"
          filters={filter}
          isLoading={isLoading}
        />
    </div>
  );
};

export default EmployeeAttendanceReportTab;
